import React, { useEffect } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid
} from '@material-ui/core';
import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';

import PaperComponent from 'components/PaperComponent';
import CloseIcon from 'images/icons/signals/closesAndCancels/closeTransparent.svg';

function BarcodeScannerModal({
  open,
  onClose,
  onDetected,
  isLoading,
  productData
}) {
  useEffect(() => {
    let scanner;

    if (open) {
      const timeoutId = setTimeout(() => {
        const element = document.getElementById('barcode-reader');

        if (element) {
          scanner = new Html5QrcodeScanner('barcode-reader', {
            fps: 10,
            qrbox: { width: 250, height: 90 },
            supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
            verbose: true
          });

          scanner.render(
            (result) => {
              scanner.clear();
              onDetected(result);
            },
            (error) => {
              // Silencia erros comuns de leitura
            }
          );
        }
      }, 500);

      return () => {
        clearTimeout(timeoutId);
        if (scanner) scanner.clear().catch(() => {});
      };
    }
  }, [open, onClose, onDetected]);

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      className="qrCodeReaderNotesDialog"
      aria-labelledby="barcode-dialog-title"
    >
      <DialogTitle className="modalHeader navyBlue bold textAlignCenter cursorMove">
        <Typography
          id="barcode-dialog-title"
          className="textAlignLeft"
          style={{ width: '90%' }}
        >
          Ler Código de Barras
        </Typography>

        <IconButton edge="start" color="inherit" onClick={onClose}>
          <img style={{ width: '16px' }} src={CloseIcon} alt="Fechar" />
        </IconButton>
      </DialogTitle>

      <DialogContent className="modalContent p12">
        <Grid
          container
          spacing={6}
          className="w100 alignCenter justifyCenter m0"
        >
          <div
            style={{ border: '1px solid black', margin: '10px 0' }}
            className="w100 qr-scanner"
          >
            {(() => {
              if (isLoading) {
                return (
                  <Typography className="textAlignCenter">
                    Buscando informações...
                  </Typography>
                );
              }
            
              return <div id="barcode-reader" />;
            })()}
          </div>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default BarcodeScannerModal;
